export enum ConditionEnum {
  Enrollment = 'enrollment',
  LastLogin = 'last_login',
}

export enum SendingFrequencyEnum {
  Once = 'once',
  Repeat = 'repeat',
}

export interface ReminderInterface {
  course: {
    emailRemindersEnabled: boolean
  }
  condition: ConditionEnum
  conditionDays: number
  reminderTime: number
  notStarted: boolean
  started: boolean
  minProgress: number
  sendingFrequency: SendingFrequencyEnum
  resendSettings?: ResendSettings
}

export enum RepeatUnitEnum {
  Day = 'day',
}

interface ResendSettings {
  repeatEvery: number
  repeatUnit: RepeatUnitEnum
  finishAfter: string | null
  maxOccurrences: number | null
}

export interface ReminderEditInterface {
  condition: ConditionEnum | undefined
  conditionDays: number
  reminderTime: number | null
  notStarted: boolean
  started: boolean
  minProgress: number
  sendingFrequency: SendingFrequencyEnum | undefined
  resendSettings?: ResendSettings
}

export interface ReminderErrorsInterface {
  condition: string
  conditionDays: string
  reminderTime: string
  sendingFrequency: string
  minProgress: string
  started: string
  resendSettings: {
    repeatEvery: string
    finishAfter: string
    maxOccurrences: string
  }
}

export interface ReminderErrorResponseInterface {
  common: string[]
  fields: {
    condition: string[]
    conditionDays: string[]
    reminderTime: string[]
    sendingFrequency: string[]
    minProgress: string[]
    started: string[]
    resendSettings: {
      repeatEvery: string[]
      finishAfter: string[]
      maxOccurrences: string[]
    }
  }
}

export interface ReminderEmailInterface {
  currentEmail: {
    subject: string
    body: string
    fromName: string
    fromEmail: string
    previewText: string
    useNewEditor: boolean
  }
}

export interface ReminderEmailErrorResponseInterface {
  common: string[]
  fields: {
    currentEmail: {
      subject: string[]
      body: string[]
      fromEmail: string[]
      fromName: string[]
      previewText?: string[]
    }
  }
}
